import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
  Alert,
  Button,
  ButtonToolbar,
  ControlLabel,
  Form,
  Image,
  FormControl,
  Table,
  ToggleButtonGroup,
  ToggleButton,
  FormGroup,
  Col,
  Row
} from "react-bootstrap"
import { browserHistory } from "react-router"
import * as ItemTypes from "../../redux/items/types"
import { initField } from "../../lib/form-builder"
import * as Validators from "../../lib/validators"
import FieldGroup from "../FieldGroup"
import FontAwesome from "react-fontawesome"
import {
  formatCollateralName,
  getDefaultCurrency,
  getOrganization,
  saveDefaultCurrency,
  validateCommissions,
  validatePercentState,
  VALIDATION_TYPE
} from "../../lib/utils"
import ProcessesStatus from "../fragments/ProcessesStatus"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import CommissionItem from "../fragments/CommissionItem"
import FormButtons from "../fragments/FormButtons"

const UPFRONT_TYPE = {
  PERCENT: 'PERCENT',
  VALUE: 'VALUE'
},

LOAN_COL_CLASSNAME = {
  HAS_SUCCESS: 'has-success',
  HAS_ERROR: 'has-error',
  NULL: '',
}

class BundleForm extends Component {

  constructor(props) {

    super(props)
    const { bundle } = this.props,
    isNew = !bundle || !bundle.id,
    commissions = (!isNew && bundle.commissions) ? bundle.commissions.filter(item => !!item) : []

    this.state = {
      running: false,
      error: null,
      isNew,

      ...initField(this, 'name', !isNew ? bundle.name : '', Validators.nonEmpty),

      ...initField(this, 'description', !isNew ? bundle.description : '', Validators.nonEmpty),

      ...initField(this, 'active', (!isNew && bundle.active === false) ? 'false' : 'true', Validators.nonEmpty),

      ...initField(this, 'cost', !isNew ? bundle.cost.toString() : '', Validators.float),

      ...initField(this, 'purchaseCost',
        (!isNew && bundle.purchaseCost) ? bundle.purchaseCost.toString() : '',
        Validators.float
      ),

      ...initField(this, 'currencyCode', !isNew ? bundle.currencyCode : getDefaultCurrency(), Validators.nonEmpty),

      ...initField(this, 'numberOfRepayments', !isNew ? bundle.numberOfRepayments : '', Validators.positiveInt),

      ...initField(this, 'repaymentEvery', !isNew ? bundle.repaymentEvery : '', Validators.positiveInt),

      ...initField(this, 'repaymentFrequencyType', !isNew ? bundle.repaymentFrequencyType : '0', Validators.nonEmpty),

      file: {},
      imagePreviewUrl: (!isNew && bundle.imageId) ? bundle.photoUrl : null,
      loanCollaterals: null,
      collateralError: null,
      loanCollateralState: LOAN_COL_CLASSNAME.NULL,
      loanCollateral: !isNew ? bundle.loanCollateral : null,
      upfrontPayment: !isNew ? bundle.upfrontPayment : 0,
      upfrontPaymentValidationState: VALIDATION_TYPE.SUCCESS,
      upfrontPaymentType: UPFRONT_TYPE.PERCENT,

      commissions,
      commissionsValidationState: VALIDATION_TYPE.NULL,

      purchaseVAT: !isNew ? bundle.purchaseVAT : '',
      sellingVAT: !isNew ? bundle.sellingVAT : '',

      purchaseVATValidationState: VALIDATION_TYPE.NULL,

      sellingVATValidationState: VALIDATION_TYPE.NULL,
    }
  
    this.handleImageChange = this.handleImageChange.bind(this)
  }

  componentDidMount() {

    const { loadLoanCommissions } = this.props,
    { isNew } = this.state

    loadLoanCommissions()
    this.getOrganizationCollateral()

    if(!isNew) {
      this.dataValidation(true)
    }
  }

  // Get organization loanCollaterals
  getOrganizationCollateral = () => {

    const organization = getOrganization(),
    collaterals = organization ? organization.loanCollaterals : null
    if(collaterals && collaterals.length) {
      this.setState({ loanCollaterals: collaterals })
    }
    else {
      this.setState({
        collateralError: 'No collaterals exist for your organization, please contact the SUPER Admin!'
      })
    }
  }

  componentWillUnmount() {
    this.setState({
      running: false,
      error: null,
      collateralError: null,
    })
  }

  getMaxInputUpfrontPayment = (upfrontPaymentType, cost) => 
    upfrontPaymentType === UPFRONT_TYPE.PERCENT ? 100 : cost.value

  loanCollateralChanged = loanCollateral => this.setState({ 
    loanCollateral,
    loanCollateralState: this.getLoanCollateralState(loanCollateral, false)
  })

  getLoanCollateralState = (loanCollateral, isStart) => loanCollateral 
    ? LOAN_COL_CLASSNAME.HAS_SUCCESS
    : isStart
      ? LOAN_COL_CLASSNAME.NULL
      : LOAN_COL_CLASSNAME.HAS_ERROR

  getUpfrontPaymentPercent = (upfrontPayment, upfrontPaymentType, bundleCost) => {
    upfrontPayment = Number(upfrontPayment)
    bundleCost = Number(bundleCost)
    return (upfrontPaymentType === UPFRONT_TYPE.VALUE)
      ? (upfrontPayment * 100) / bundleCost
      : upfrontPayment
  }

  validateUpfrontPayment = (upfrontPayment, upfrontPaymentType, bundleCost) => {

    upfrontPayment = Number(upfrontPayment)
    bundleCost = Number(bundleCost)
    if(isNaN(bundleCost)
      || isNaN(upfrontPayment)
      || upfrontPayment < 0
      || (upfrontPaymentType === UPFRONT_TYPE.PERCENT && upfrontPayment > 100)
      || (bundleCost > 0 && upfrontPaymentType === UPFRONT_TYPE.VALUE && upfrontPayment > bundleCost)) {
      return VALIDATION_TYPE.ERROR
    }

    return VALIDATION_TYPE.SUCCESS
  }

  upfrontPaymentChanged = (upfrontPayment, upfrontPaymentType, cost) => this.setState({
    upfrontPayment,
    upfrontPaymentValidationState: this.validateUpfrontPayment(
      upfrontPayment,
      upfrontPaymentType,
      cost.value
    ),
  })

  upfrontPaymentTypeChanged = (upfrontPayment, upfrontPaymentType, cost) => {

    const bundleCost = cost.value
    upfrontPayment = (bundleCost && !isNaN(bundleCost))
      ? upfrontPaymentType === UPFRONT_TYPE.PERCENT
        ? (upfrontPayment * 100) / bundleCost
        : (upfrontPayment * bundleCost) / 100
      : 0

    this.setState({
      upfrontPayment,
      upfrontPaymentType,
      upfrontPaymentValidationState: this.validateUpfrontPayment(
        upfrontPayment,
        upfrontPaymentType,
        bundleCost
      ),
    })
  }

  commissionChanged = (id, index) => {

    const { commissions } = this.state,
    current = commissions[index]
    current.id = id
    commissions[index] = current

    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, false),
      error: null,
    })
  }

  removeCommission = index => {
    const { commissions } = this.state
    commissions.splice(index, 1)
    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, false),
      error: null,
    })
  }

  addNewCommission = () => {
    const { commissions } = this.state
    commissions.push({ id: '' })
    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, true),
      error: null,
    })
  }

  handleImageChange(e) {

    e.preventDefault()
    const file = e.target.files[0]
    if(!file) return

    const reader = new FileReader()
    reader.onloadend = () => this.setState({
      file,
      imagePreviewUrl: reader.result
    })
    reader.readAsDataURL(file)
  }

  purchaseVATChanged = purchaseVAT => this.setState({
    purchaseVAT,
    purchaseVATValidationState: validatePercentState(purchaseVAT, false),
    error: null,
  })

  sellingVATChanged = sellingVAT => this.setState({
    sellingVAT,
    sellingVATValidationState: validatePercentState(sellingVAT, false),
    error: null,
  })

  dataValidation = isStart => {

    const { name, description, active, cost, purchaseCost, currencyCode, numberOfRepayments,
      repaymentEvery, repaymentFrequencyType, loanCollateral, upfrontPayment,
      upfrontPaymentType, commissions, purchaseVAT, sellingVAT } = this.state

    name.validationCurrentValue()
    description.validationCurrentValue()
    active.validationCurrentValue()
    cost.validationCurrentValue()
    purchaseCost.validationCurrentValue()
    currencyCode.validationCurrentValue()
    numberOfRepayments.validationCurrentValue()
    repaymentEvery.validationCurrentValue()
    repaymentFrequencyType.validationCurrentValue()

    this.setState({
      loanCollateralState: this.getLoanCollateralState(loanCollateral, isStart),
      upfrontPaymentValidationState: this.validateUpfrontPayment(
        upfrontPayment,
        upfrontPaymentType,
        cost.value
      ),
      commissionsValidationState: validateCommissions(commissions, false),
      purchaseVATValidationState: validatePercentState(purchaseVAT, false),
      sellingVATValidationState: validatePercentState(sellingVAT, false),
    })
  }

  valid = () => {

    const { name, description, active, cost, purchaseCost, currencyCode, numberOfRepayments,
      repaymentEvery, repaymentFrequencyType, loanCollateral, commissions,
      purchaseVAT, sellingVAT } = this.state,

    areCommissionsValid = commissions.every(item => item.id),

    purchaseVATValid = validatePercentState(purchaseVAT, false),

    sellingVATValid = validatePercentState(sellingVAT, false)

    return !!(

      name.validation &&
      name.validation.valid &&

      description.validation &&
      description.validation.valid &&

      cost.validation &&
      cost.validation.valid &&

      purchaseCost.validation &&
      purchaseCost.validation.valid &&

      active.value &&

      currencyCode.value &&

      numberOfRepayments.validation &&
      numberOfRepayments.validation.valid &&

      repaymentEvery.validation &&
      repaymentEvery.validation.valid &&

      repaymentFrequencyType.value >= 0 &&

      loanCollateral &&

      areCommissionsValid &&

      purchaseVATValid === VALIDATION_TYPE.SUCCESS &&

      sellingVATValid === VALIDATION_TYPE.SUCCESS
    )
  }

  saveClicked = () => {

    this.setState({ error: null })
    this.dataValidation(false)

    if(this.valid()) {

      const { name, description, active, cost, purchaseCost, currencyCode, numberOfRepayments,
      repaymentEvery, repaymentFrequencyType, loanCollateral, upfrontPayment,
      upfrontPaymentType, file, commissions, purchaseVAT, sellingVAT } = this.state,

      // Automatically compute the loan term
      loanTerm = Number(numberOfRepayments.value) * Number(repaymentEvery.value),
      loanTermFrequencyType = repaymentFrequencyType.value,
      bundleCost = cost.value,

      { bundle, onSaveClicked } = this.props
      saveDefaultCurrency(currencyCode.value)

      const data = {
        id: bundle.id,
        imageId: bundle.imageId,
        name: name.value,
        description: description.value,
        cost: bundleCost,
        purchaseCost: purchaseCost.value,
        loanCollateral: loanCollateral,
        active: active.value,
        currencyCode: currencyCode.value,
        loanTermFrequency: loanTerm,
        loanTermFrequencyType: loanTermFrequencyType,
        numberOfRepayments: numberOfRepayments.value,
        repaymentEvery: repaymentEvery.value,
        repaymentFrequencyType: repaymentFrequencyType.value,
        file,
        upfrontPayment: this.getUpfrontPaymentPercent(
          upfrontPayment,
          upfrontPaymentType,
          bundleCost
        ),
        commissions,
        purchaseVAT,
        sellingVAT,
      }

      onSaveClicked(data)
    }
    else {
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  renderValueOfPercent = (upfrontPayment, upfrontPaymentType, cost, currencyCode) => {

    if(upfrontPaymentType === UPFRONT_TYPE.VALUE) return null

    let r = '_'
    const bundleCost = cost.value
    upfrontPayment = Number(upfrontPayment)
    if(bundleCost && !isNaN(bundleCost) && !isNaN(upfrontPayment)) {
      const result = (upfrontPayment * bundleCost) / 100
      r = Math.round((result + Number.EPSILON) * 100) / 100
    }

    return <span className="gray">Value: { currencyCode.value } { r }</span>
  }

  renderLoanCollateral = (loanCollateralState, loanCollateral, loanCollaterals, running) => (
    <div className={ loanCollateralState }>

      <ControlLabel className='control-label'>Loan collateral</ControlLabel>

      <ButtonToolbar>

        <ToggleButtonGroup
          onChange={ this.loanCollateralChanged }
          type="radio"
          name="loanCollateral"
          defaultValue={ loanCollateral }>
        { loanCollaterals &&
          loanCollaterals.map((value, index) => (
            <ToggleButton key={ index } value={ value } disabled={ running }>
              { formatCollateralName(value) }
            </ToggleButton>
          ))
        }
        </ToggleButtonGroup>

      </ButtonToolbar>

      { loanCollateralState === LOAN_COL_CLASSNAME.HAS_ERROR &&
        <span className='help-block'>Choose a loan collateral</span>
      }
    </div>
  )

  renderLoanCommissions = running => {

    const { loanCommissions } = this.props,
    { commissions, commissionsValidationState } = this.state

    return (
      <FormGroup controlId='loanCommissions' className="mb-20"
        validationState={ commissionsValidationState }>

        <Row>
          <Col componentClass={ ControlLabel } sm={4}>
            Commissions
          </Col>

          <Col sm={8}>

            { commissions.map((item, index) => 
              <CommissionItem
                key={ `table${index}` }
                item={ item } 
                index={ index }
                loanCommissions={ loanCommissions}
                onChange={ this.commissionChanged } 
                onRemove={ this.removeCommission }
                disabled={ running }
              />
            )}

            <Button onClick={ this.addNewCommission } bsStyle="link" title='Add new item'
              disabled={ running }>
              <FontAwesome name="plus" /> Add
            </Button>
          </Col>
        </Row>
      </FormGroup>
    )
  }

  renderRepaymentDetails = running => {

    const { cost, purchaseCost, currencyCode,
      numberOfRepayments, repaymentEvery, repaymentFrequencyType, upfrontPaymentValidationState,
      upfrontPaymentType, upfrontPayment } = this.state

    return (
      <Table>
        <tbody>
          <tr>
            <td>
              <FieldGroup
                label="Selling price (VAT Incl.)"
                id="cost"
                type="text"
                placeholder="Enter cost"
                value={ cost.value }
                onChange={ cost.onChange }
                validationState={ cost.validation }
                validationMessage="Please enter a valid cost, it must be a float"
                bsClass="form-control"
                disabled={ running }
              />
            </td>

            <td>
              <FormControl
                id="currencyCode"
                componentClass="select"
                placeholder="Select"
                value={ currencyCode.value }
                onChange={ currencyCode.onChange }
                className="marginLeftTop"
                disabled={ running }
              >
                <option value="USD" title="US Dollar">USD ($)</option>
                <option value="EUR" title="Euro">EUR (€)</option>
                <option value="RWF" title="Rwanda Franc">Rwanda Franc</option>
              </FormControl>
            </td>
          </tr>

          <tr>
            <td>
              <FieldGroup
                label="Purchase cost (VAT Incl.)"
                id="purchaseCost"
                type="text"
                placeholder="Enter purchase cost"
                value={ purchaseCost.value }
                onChange={ purchaseCost.onChange }
                validationState={ purchaseCost.validation }
                validationMessage="Enter a valid amount"
                bsClass="form-control"
                disabled={ running }
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <FieldGroup
                label="Number of repayments"
                id="numberOfRepayments"
                type="number"
                placeholder="Number of repayments"
                value={ numberOfRepayments.value }
                onChange={ numberOfRepayments.onChange }
                validationState={ numberOfRepayments.validation }
                validationMessage="Value must be a positive int"
                bsClass="form-control"
                min={1}
                disabled={ running }
              />
            </td>
          </tr>

          <tr>
            <td>
              <FieldGroup
                label="Repaid every"
                id="repaymentEvery"
                type="number"
                placeholder="Repayment frequency"
                value={ repaymentEvery.value }
                onChange={ repaymentEvery.onChange }
                validationState={ repaymentEvery.validation }
                validationMessage="Value must be a positive int"
                bsClass="form-control"
                min={1}
                disabled={ running }
              />
            </td>

            <td>
              <FormControl 
                id="repaymentFrequencyType" 
                componentClass="select" 
                placeholder="Select"
                value={ repaymentFrequencyType.value }
                onChange={ repaymentFrequencyType.onChange }
                className="marginLeftTop"
                disabled={ running }
              >
                <option value="0">Days</option>
                <option value="1">Weeks</option>
                <option value="2">Months</option>
                <option value="3">Years</option>
              </FormControl>
            </td>
          </tr>

          <tr>
            <td>
              <FormGroup controlId='upfrontPayment' validationState={ upfrontPaymentValidationState }>
                <ControlLabel>Upfront payment</ControlLabel>
                <FormControl
                  type="number"
                  label="Upfront Payment"
                  placeholder={upfrontPaymentType === UPFRONT_TYPE.PERCENT ? 'Percentage' : 'Fixed value'}
                  value={ upfrontPayment }
                  onChange={e => this.upfrontPaymentChanged(e.target.value, upfrontPaymentType, cost)}
                  min={0}
                  max={ this.getMaxInputUpfrontPayment(upfrontPaymentType, cost) }
                  disabled={ running }
                />
              </FormGroup>
              { this.renderValueOfPercent(upfrontPayment, upfrontPaymentType, cost, currencyCode) }
            </td>
            <td>
              <FormControl 
                id="upfrontPaymentType" 
                componentClass="select" 
                placeholder="Select"
                value={ upfrontPaymentType }
                onChange={e => this.upfrontPaymentTypeChanged(upfrontPayment, e.target.value, cost)}
                className="marginLeftTop"
                disabled={ running }>
                <option value={ UPFRONT_TYPE.PERCENT }>Percent (%)</option>
                <option value={ UPFRONT_TYPE.VALUE }>{ currencyCode.value }</option>
              </FormControl>
            </td>
          </tr>

        </tbody>
      </Table>
    )
  }

  renderVAT = running => {

    const { purchaseVAT, sellingVAT, purchaseVATValidationState, sellingVATValidationState } = this.state

    return (
    <Table>
      <tbody>
        <tr>
          <td>
            <FormGroup controlId='purchaseVAT' validationState={ purchaseVATValidationState }>
              <ControlLabel>VAT Purchase cost (%)</ControlLabel>
              <FormControl
                type="number"
                placeholder='VAT Purchase (%)'
                value={ purchaseVAT }
                onChange={e => this.purchaseVATChanged(e.target.value )}
                min={0}
                max={100}
                disabled={ running }
              />
              <FormControl.Feedback />
            </FormGroup>
          </td>

          <td>
            <FormGroup controlId='sellingVAT' validationState={ sellingVATValidationState }>
              <ControlLabel>VAT Selling cost (%)</ControlLabel>
              <FormControl
                type="number"
                placeholder='VAT Selling (%)'
                value={ sellingVAT }
                onChange={e => this.sellingVATChanged(e.target.value )}
                min={0}
                max={100}
                disabled={ running }
              />
              <FormControl.Feedback />
            </FormGroup>
          </td>
        </tr>
      </tbody>

    </Table>
    )
  }

  render() {
    const { bundle, running, success, error } = this.props,

    { isNew, collateralError, active, name, description, imagePreviewUrl, error: stateError, 
      loanCollateralState, loanCollateral, loanCollaterals } = this.state,

    dataBreadCrumbs = [{ url: '/bundles', title: 'Bundles' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ bundle.name ? bundle.name : 'New' } data={ dataBreadCrumbs } />

        <div className="simple-form max-width-700 mx-auto mb-20">

          { !!collateralError && <Alert bsStyle="danger">{ collateralError }</Alert> }

          <Form >
            <h3 className="text-center">
              { isNew ? 'New bundle' : 'Update bundle' }
            </h3>
            <hr/>

            <FormGroup controlId='status' className="mb-20"
              validationState={ VALIDATION_TYPE.SUCCESS }>
              <ControlLabel>Status</ControlLabel>
              <FormControl
                componentClass="select"
                placeholder="Select"
                value={ active.value }
                onChange={ active.onChange }
                disabled={ running }
              >
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </FormControl>
            </FormGroup>
            <br/>

            <FieldGroup
              label="Name"
              id="name"
              type="text"
              placeholder="Enter name"
              value={ name.value }
              onChange={ name.onChange }
              validationState={ name.validation }
              validationMessage="Name must not be empty"
              bsClass="form-control"
              disabled={ running }
            />
            <br/>

            <FieldGroup
              label="Description"
              id="description"
              type="text"
              placeholder="Enter description"
              value={ description.value }
              onChange={ description.onChange }
              validationState={ description.validation }
              validationMessage="Description must not be empty"
              bsClass="form-control"
              disabled={ running }
            />

            { this.renderLoanCollateral(loanCollateralState, loanCollateral, loanCollaterals, running) }
            <br/>

            { this.renderRepaymentDetails(running) }

            { this.renderVAT(running) }

            <hr/>

            { this.renderLoanCommissions(running) }
            
            <hr/>

            <ControlLabel>Bundle photo</ControlLabel>
            <br/>
            { !!imagePreviewUrl && <Image alt="Bundle photo" src={ imagePreviewUrl } rounded /> }
            <input
              id="upload-image"
              accept="image/jpeg,image/jpg"
              type="file"
              onChange={ this.handleImageChange }
            />
            <br/>

          </Form>

          <ProcessesStatus
            error={ error || stateError }
            running={ running }
            success={ success }
          />

          <FormButtons onSave={ this.saveClicked } 
            onCancel={() => browserHistory.push('/bundles')} 
            running={ running }
          />
        </div>
      </div>
    )
  }
}

BundleForm.propTypes = {
  bundle: PropTypes.object.isRequired,
  onSaveClicked: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  const loanCommissions = DckSelectors.selectAllItems(state, ItemTypes.LoanCommission)
  return { loanCommissions }
}

const mapDispatchToProps = dispatch => ({
  loadLoanCommissions: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.LoanCommission)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BundleForm)



// WEBPACK FOOTER //
// ./src/components/Bundles/Form.js